import React, { Component, ChangeEvent } from 'react';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import { ListGroup, ListGroupItem, Glyphicon } from 'react-bootstrap'
import ConfigurationStore from '../stores/ConfigurationStore';
import { FormGroup, FormControl, Button, InputGroup } from 'react-bootstrap';
import { AllStores } from '../stores';
import validate from 'validator';

type NotificationTypesState = {
    name: string
};

type NotificationTypesProps = {
    configurationStore: ConfigurationStore;
}

@inject((allStores: AllStores) => {
    return {
        configurationStore: allStores.configurationStore as ConfigurationStore
    };
})
@observer
class NotificationTypes extends Component<NotificationTypesProps, NotificationTypesState> {
    state: NotificationTypesState = {
        name: '',
    };

    componentDidMount() {
        this.props.configurationStore.getNotificationTypes();
    }

    updateName = (event : ChangeEvent<EventTarget>) => {
        const target = event.target as HTMLInputElement;
        this.setState({ name: target.value });
    };

    saveName = () => {
        const name = this.state.name.trim();
        //TODO: prevent duplicate entry
        if(validate.isAlpha(name) && !validate.isEmpty(name))
            this.props.configurationStore.createNotificationType(this.state.name);
    }

    render() {
        const { notificationTypes } = this.props.configurationStore;
        const { name } = this.state;

        return (
            <form className='notification-types-form'>
                <h1>Notification Types</h1>
                <span>Click on a type to edit it</span>
                <hr></hr>
                <div>
                    <h5>Add new type?</h5>
                    <div className='item form-inline'>
                        <FormGroup>
                            <InputGroup className='name mr-3'>
                                <InputGroup.Addon>Name</InputGroup.Addon>
                                <FormControl type='text' value={name} onChange={this.updateName} placeholder='New type' />
                            </InputGroup>
                            <Button bsStyle='success' onClick={this.saveName}>Add</Button>
                        </FormGroup>
                        <hr></hr>
                    </div>
                    {
                        notificationTypes.map(type => {
                            return <div className='item form-inline' key={type.id}>
                                <Link to={`/notification-type/${type.id}`} className='text-no-underline'>
                                    <ListGroup>
                                        <ListGroupItem header={type.name}>
                                            <small>Fields: </small>
                                            {type.fields.map((field : any, index : number) => {
                                                return (
                                                    <small key={field.id}>
                                                        { (index ? ', ' : '') + field.name }
                                                    </small>
                                                )
                                            })}
                                            &nbsp;<Glyphicon glyph='pencil'></Glyphicon>
                                        </ListGroupItem>
                                    </ListGroup>
                                </Link>
                            </div>;
                        })
                    }
                </div>
            </form>
        );
    }
}


export { NotificationTypes };